import styled from 'styled-components'

import { ColumnFlex, FlexCentered } from 'components/common/genericStyles'

export const Container = styled.div`
    height: 100%;
    position: relative;
    z-index: 18;
    ${FlexCentered}
`

export const Row = styled.div`
    ${FlexCentered}
    justify-content: space-between;

    ${props =>
        props.rowReverse &&
        `flex-direction: row-reverse;
         flex-basis: 50%;
       `}

    & > div {
        margin-right: 8px;
    }
`

export const Content = styled.div`
    ${ColumnFlex}
    ${props => props.flexBasis && `flex-basis: ${props.flexBasis};`}
`
